<template>
  <div class="container">
    <div class="slider">
      <div v-for="(step, index) in steps" :key="index">
        <div
          @click="handleStepClick(index)"
          @keyDown.enter="handleStepClick(index)"
          :class="{ 'slider-number': true, active: active === index }"
          :style="active === index ? activeColor : ''">
          {{ step[attributeNameForStepTitle] }}
        </div>
        <div v-if="index < steps.length - 1" :class="{ 'slider-divisor': true }" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'dx-license-stepper',

  props: {
    steps: {
      type: Array,
      required: true,
    },
    active: Number,
    activeStepIndex: Number,
    attributeNameForStepTitle: {
      type: String,
      default: 'label',
    },
    activeStepColor: {
      type: String,
      default: 'blue-semi-light',
    },
  },

  data() {
    return {};
  },

  computed: {
    activeColor() {
      const textColor = {
        yellow: 'dark-grey',
        grey: 'white',
        blue: 'white',
      };
      return `background: var(--dx-color--${this.activeStepColor}); color: var(--dx-color--${textColor[this.activeStepColor]});`;
    },
  },

  methods: {
    handleStepClick(index) {
      this.$emit('change-step', index, this.activeStepIndex);
    },
  },
};
</script>

<style scoped lang="scss">
.slider-number {
  padding: 7px;
  width: 35px;
  height: 35px;
  margin: 5px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  border: 1px solid;
  border-color: var(--dx-color--blue-semi-light);
  color: var(--dx-color--blue-semi-light);
  float: left;
  background: var(--dx-color--white);
  font-size: 11px;
  cursor: pointer;

  &:hover {
    background-color: var(--dx-color--blue-light);
    color: var(--dx-color--grey);
    border: 2px solid;
  }
}

.slider-divisor {
  float: left;
  height: 4px;
  width: calc(50% - 68px);
  margin: 20px 0;
  background: var(--dx-color--blue-semi-light);
}

.slider {
  margin: 5px 10px 25px;

  &::after {
    content: '';
    display: table;
    clear: both;
  }
}

.container {
  margin-left: auto;
  margin-right: auto;
}
</style>
